import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9.29956 3.98526C9.29956 4.70199 8.71853 5.28302 8.0018 5.28302C7.28507 5.28302 6.70404 4.70199 6.70404 3.98526C6.70404 3.26853 7.28507 2.6875 8.0018 2.6875C8.71853 2.6875 9.29956 3.26853 9.29956 3.98526ZM9.0036 12.9956H7.0036L7.0036 6.46435H9.0036V12.9956Z",
		fill: "#005AA0"
	})]
});
const ForwardRef = forwardRef(SvgInfoFilled);
export { ForwardRef as ReactComponent };
